import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";

const emailsUrl = "/api/v1/email";
const emailSubscriptionUrl = "/email";
const email = "/api/v1/SubscriberEmail";

export interface SubscribeToListApiParameter extends ApiParameter {
    emailAddress: string;
}

export function subscribeToList(parameter: SubscribeToListApiParameter): Promise<string> {
    const result = post(`${email}/add`, parameter.emailAddress);
    return result;
}
